import React, { useContext, useEffect } from 'react';

import LayoutContext from 'context/layout';
import { Container } from 'styles';
import { Subtitle, Title, Sentence, Bold, Paragraph } from 'styles/Layout';

const TermsPage = () => {
    const { setState } = useContext(LayoutContext);

    useEffect(() => {
		setState({ isHome: false, displaySearch: false });
	}, []);

    useEffect(() => () => {
        setState({ isHome: false, displaySearch: true });
	}, []);


	return (
        <div style={{margin: '2rem 0'}}>
            <Container>
                <Title>Política de privacidade</Title>
                <Paragraph>
                    <Sentence>A presente Política de Privacidade explica como usamos,  coletamos, divulgamos e compartilhamos os dados pessoais que você fornece quando você usa nosso website que esteja relacionado à presente política ou faça negócios conosco (os Serviços). O tratamento dos seus dados pessoais será regulado por essa Política de Privacidade.</Sentence>
                </Paragraph>

                <Subtitle>1. Dados pessoais</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>1.1)</Bold> Ao comprar ingressos ou cadastrar-se em eventos disponíveis no site haverá a coleta dos dados pessoais dos usuários, que ficarão armazenados nos servidores da plataforma como: nome completo, endereço, telefone celular, CPF, data de nascimento e e-mail. Estes dados são os mínimos necessários para a aquisição dos ingressos pelos usuários.
                    </Sentence>
                    <Sentence>
                        <Bold>1.2)</Bold> Dependendo do evento, dados extras podem ser solicitados pela produção do evento, ficando ao critério de cada usuário fornecer as suas informações. Tais informações serão gravadas apenas para este evento e não serão utilizados para outros fins.
                    </Sentence>
                    <Sentence>
                        <Bold>1.3)</Bold> Os dados de pagamento e efetivação da compra, exigidas para o processamento da transação, bem como, os dados do cartão de crédito dos usuários, não são armazenados nos servidores da plataforma.
                    </Sentence>
                    <Sentence>
                        <Bold>1.4)</Bold> Além das informações recebidas durante os procedimentos de cadastro e pagamento, descritos acima, também há o recebimento de informações quando o usuário entra em contato com a plataforma ou responde a uma de suas pesquisas. Estas informações podem ser incluídas no cadastro de cada usuário.
                    </Sentence>
                    <Sentence>
                        <Bold>1.5)</Bold> Os usuários assumem a responsabilidade sobre as informações pessoais que estão fornecendo à plataforma, bem como, as consequências de suas decisões.
                    </Sentence>
                </Paragraph>

                <Subtitle>2. Dados de navegação e cookies</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>2.1)</Bold> Ao acessar e interagir com o site e aplicativos, coletamos informações que podem identificar direta ou indiretamente um usuário em particular, como o endereço IP utilizado, sua localização geográfica aproximada, o registro das páginas visitadas, tempos de visita e outras informações agregadas.
                    </Sentence>
                    <Sentence>
                        <Bold>2.2)</Bold> Cookies são pequenos trechos de texto usados para armazenar informações em navegadores da Web. Os cookies são usados para armazenar e receber identificadores e outras informações em computadores, telefones e outros dispositivos. Outras tecnologias, inclusive os dados que armazenamos em seu navegador ou dispositivo, identificadores associados ao seu dispositivo e outro software, são usados com finalidades semelhantes.
                    </Sentence>
                    <Sentence>
                        <Bold>2.3)</Bold> A plataforma utiliza cookies para ajudar a identificar os visitantes e evitar, por exemplo, que a senha do usuário tenha que ser digitada várias vezes durante a utilização do site. O navegador ou dispositivo pode ter configurações que permitam ao usuário escolher se quer definir cookies ou não e excluí-los. Determinadas partes dos Serviços da plataforma poderão não funcionar corretamente se o uso de cookies do navegador tiver sido desativado.
                    </Sentence>
                    <Sentence left="3rem">
                        <Bold>2.3.1)</Bold> Caso você não queira permitir que tais cookies sejam instalados em seu computador, recomendamos que configure seu navegador (browser) de forma que você seja alertado antes que um cookie lhe seja enviado e possa recusá-lo. Como remover os cookies de seu navegador:  1. No computador, abra o seu navegador;  2. No canto superior direito, clique em Configurações; 3. Em "Privacidade e segurança", clique em Cookies e outros dados do site; 4. Clique em ver todos os cookies e dados do site- Remover tudo; 5. Confirme clicando em Limpar.
                    </Sentence>
                </Paragraph>

                <Subtitle>3. Como utilizamos as informações coletadas</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>3.1)</Bold> Vale reforçar que todas as informações coletadas são para fornecer o melhor serviço. As suas informações são sempre trafegadas utilizando criptografia e guardadas em servidores, que observam padrões rígidos de segurança, inviolabilidade e confiabilidade, de modo a garantir a intimidade, vida privada, honra e imagem dos usuários.
                    </Sentence>
                    <Sentence>
                        <Bold>3.2)</Bold> Mediante requerimento do usuário, a plataforma procederá à exclusão definitiva dos dados pessoais, salvo nos casos de guarda obrigatória.
                    </Sentence>
                </Paragraph>

                <Subtitle>4. Confirmação de conta</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>4.1)</Bold> Para garantir a entrega segura dos nossos serviços, é necessário, ao se cadastrar, confirmar o cadastro e ativar a conta, através de um e-mail que o usuário irá receber da plataforma. Ao proceder ao cadastro e confirmá-lo por e-mail, o usuário expressa o consentimento sobre coleta, uso, armazenamento e tratamento de dados pessoais pela plataforma.
                    </Sentence>
                    <Sentence>
                        <Bold>4.2)</Bold> Na efetivação da compra, o cadastro poderá ser submetido ao departamento de segurança de informações da plataforma, que poderá entrar em contato com o usuário e solicitar detalhamento das informações.
                    </Sentence>
                </Paragraph>

                <Subtitle>5. Comprovante de compras/entrega de ingressos</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>5.1)</Bold> Após a efetivação das compras, o usuário receberá um e-mail no endereço eletrônico indicado. Assim, é muito importante que os dados do usuário estejam sempre atualizados na plataforma.
                    </Sentence>
                    <Sentence>
                        <Bold>5.2)</Bold> Qualquer eventualidade com as apresentações, cancelamentos e/ou avisos, a equipe da plataforma utilizará as informações cadastrais para entrar em contato e oferecer o melhor serviço.
                    </Sentence>
                </Paragraph>

                <Subtitle>6. Melhorias no serviços</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>6.1)</Bold> Informações sobre o comportamento dos usuários na nossa plataforma, como por exemplo, quantas vezes visitou o site também poderão ser armazenados e serão utilizados para aprimoramento dos serviços oferecidos e ações de marketing mediante consentimento explícito.
                    </Sentence>
                </Paragraph>

                <Subtitle>7. Com que compartilhamos estas informações</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>7.1)</Bold> Os dados pessoais serão disponibilizados apenas a empregados autorizados e repassados aos produtores, patrocinadores e empresas envolvidas no evento que se comprometem a cumprir a presente política de privacidade, não sendo compartilhados publicamente ou utilizados para finalidades que não as propostas inicialmente.
                    </Sentence>
                    <Sentence>
                        <Bold>7.2)</Bold> Salvo disposições legais, a plataforma não fornecerá a terceiros, a informação de dados pessoais, registros de conexão e de acesso a aplicações de internet.
                    </Sentence>
                </Paragraph>

                <Subtitle>8. Direitos do titular</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>8.1)</Bold> O titular dos dados tratados pela plataforma pode a qualquer momento, mediante requisição, obter as seguintes ações:
                    </Sentence>
                    <Sentence left="3rem">
                        a. Confirmação, acesso, correção de dados: O titular tem direito de confirmar quais os dados e a forma de tratamento, bem como a correção ter acesso a estes e corrigir os dados incompletos, inexatos ou desatualizados que estejam sendo tratados;
                    </Sentence>
                    <Sentence left="3rem">
                        b. Anonimização, bloqueio ou eliminação dos dados pessoais adquiridos através do Consentimento de tratamento, ou de dados excessivos ou desnecessários ao fim pretendido;
                    </Sentence>
                    <Sentence left="3rem">
                        c. Coletar os dados que nos foram enviados para transferir a terceiros;
                    </Sentence>
                </Paragraph>

                <Subtitle>9. Mudanças na política de privacidade</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>9.1)</Bold> As ferramentas da plataforma estão em constante evolução e pode ser necessário atualizar esta política. A cada mudança nessa política de privacidade atualizaremos a data da última modificação, disponível no começo da página e a continuidade na utilização dos serviços indicará consentimento com as novas políticas.
                    </Sentence>
                </Paragraph>

                <Subtitle>10. Acordo</Subtitle>
                <Paragraph>
                    <Sentence>
                        <Bold>10.1)</Bold> Ao utilizar nosso site e aplicativos, você concorda com a Política de Privacidade contida neste documento. Para dúvidas acerca dos seus dados pessoais tratados pela plataforma, entre em contato com a nossa equipe.
                    </Sentence>
                </Paragraph>
            </Container>
        </div>
	);
};

export default TermsPage;
